export default __webpack_public_path__ + "assets/img/icon-pw-show@2x.211970e1506b48af35b4273258c93334.svg";